import { Generico, OCR } from '@/interfaces'
import { Constants } from '@/services'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { IPreAnalysisDocuments } from '@/interfaces/IPreAnalysisDocuments'

const http = AttaHttpClientFactory.create(Constants.API.AttaServices.host)

export class DocumentosService {
	/**
	 * Extrai os dados de um documento (imagem)
	 * @param base64 Imagem na base64
	 * @returns
	 */
	static async OCR(base64: string) {
		var response = await http.post<Generico.IApiResponse<OCR.IResult>>('/ocr/extract', {
			file: base64
		})

		return response.data.result
	}

	static async getDocxDocumentsFromPreAnalysisId(preAnalysisId: number) {
		var response = await http.get<IPreAnalysisDocuments>(`/document/sync-preanalysis-documents-from-docx/${preAnalysisId}`)
		return response.data
	}

	static async syncDocxDocumentsFormPreAnalysisId(preAnalysisId: number) {
		var response = await http.post<boolean>(`/document/sync-preanalysis-documents-from-docx/${preAnalysisId}`)
		return response.data
	}
}
